<template>
	<div id="recruit-detail">
		<van-row id="info-container" type="flex" justify="space-between">
			<van-col class="info">
				<div class="info-name">{{ item.name }}</div>
				<div class="info-threshold">
					<span>{{ item.experience }}</span
					>&nbsp;|&nbsp;<span>{{ item.education }}</span>
				</div>
				<div class="info-company">{{ item.company }}</div>
				<van-col class="salary" v-if="item.is_face == 0">{{ item.min_salary }}K - {{ item.max_salary }}K</van-col>
				<van-col class="salary" v-else>薪酬面议</van-col>
			</van-col>
		</van-row>
		<div id="description-container">
			<div class="item">
				<div class="title">工作地点</div>
				<p class="description">{{ work_place }}</p>
			</div>
			<div class="item">
				<div class="title">公司简介</div>
				<p class="description">{{ company_profile }}</p>
			</div>
			<div class="item">
				<div class="title">公司福利</div>
				<p class="description">{{ item.welfare }}</p>
			</div>

			<div class="item">
				<div class="title">职位描述</div>
				<p class="description" v-html="item.introduce"></p>
			</div>

			<div class="item">
				<div class="title">任职要求</div>
				<div class="description" v-html="item.skill"></div>
			</div>
		</div>
		<div id="footer">
			<van-button id="btn-apply" type="info" block @click="goApplying">申请</van-button>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import toastLoading from '../../util/toastLoading'
export default {
	data() {
		return {
			item: {
				id: '',
				name: '',
				experience: '',
				education: '',
				min_salary: '',
				max_salary: '',
				welfare: '',
				introduce: '',
				skill: '',
				company: '',
				is_face: '',
				work_place: '',
				company_profile: '',
			},
		}
	},
	computed: {
		...mapGetters(['token', 'userId', 'communityId']),
	},
	created() {
		this.getData()
	},
	methods: {
		async getData() {
			toastLoading.showLoading('加载中...')
			try {
				let res = await this.vaxios.getApi(`${this.vaxios.host}/open/api/v1/recruits/${this.$route.query.id}/detail`)
				toastLoading.clearLoading()
				if (res.code !== 1 || !res.data) return
				let data = res.data
				this.item.id = data.id
				this.item.name = data.name
				this.item.experience = this.$route.query.experience_name
				this.item.company = this.$route.query.company_name
				this.item.min_salary = data.min_salary
				this.item.max_salary = data.max_salary
				this.item.welfare = data.welfare
				this.item.introduce = data.introduce
				this.item.skill = data.skill
				this.item.is_face = data.is_face
				this.work_place = data.work_place
				this.company_profile = data.company_profile
				this.item.education = this.filteReducationType(data.education)
			} catch (_) {
				toastLoading.clearLoading()
			}
		},
		goApplying() {
			this.$router.push({
				path: '/recruit/applying',
				query: { id: this.$route.query.id },
			})
		},
		filteReducationType(type) {
			let typeObj = {
				'6': '高中',
				'7': '中专',
				'8': '大专',
				'9': '本科以上',
				'10': '不限',
			}
			return typeObj[type]
		},
	},
}
</script>

<style scoped>
#info-container {
	background: #ffffff;
	box-shadow: 0px 1px 18px rgba(0, 0, 0, 0.09);
	border-radius: 14px;
	margin: 16px;
	padding: 20px;
}

.info-name {
	color: #000000;
	font-size: 1rem;
	font-weight: bold;
}

.info-threshold {
	margin-top: 0.25rem;
	font-size: 0.75rem;
	color: #5c5c5c;
}

.info-company {
	margin-top: 0.35rem;
	font-size: 0.75rem;
	color: #5c5c5c;
}

.salary {
	margin-top: 0.55rem;
	font-size: 0.875rem;
	color: #fc5e18;
	font-weight: bold;
}

#description-container .item {
	margin: 0 26px;
}

.title {
	font-size: 1rem;
	font-weight: bold;
}

.description {
	margin-top: 8px;
	margin-bottom: 16px;
	font-size: 0.875rem;
	color: #5c5c5c;
}

#footer {
	position: fixed;
	bottom: 0;
	z-index: 999;
	width: 100%;
	height: 3.3125rem;
	margin: 0;
	background-color: #ffffff;
	opacity: 1;
}

.van-divider {
	margin: 0;
}

#btn-apply {
	position: absolute;
	right: 0;
	font-size: 1.125rem;
	height: 3.28125rem;
	margin-left: 16px;
	border-radius: 0;
}
</style>
